export default {
  recommendations: '/msvc/v1/recommendations',
  events: '/msvc/v1/events',
  accounts: '/msvc/v1/accounts',
  pushNotifications: '/msvc/v1/notifications/configurations',
  userGroups: 'msvc/v1/usergroups/'
}
